// src/components/markdown/Code.tsx - Fixed for proper containment
import React from 'react';
import type { CustomComponent } from './types';
import { Light as SyntaxHighlighter } from 'react-syntax-highlighter';
// Import specific languages to reduce bundle size
import javascript from 'react-syntax-highlighter/dist/cjs/languages/hljs/javascript';
import typescript from 'react-syntax-highlighter/dist/cjs/languages/hljs/typescript';
import python from 'react-syntax-highlighter/dist/cjs/languages/hljs/python';
import xml from 'react-syntax-highlighter/dist/cjs/languages/hljs/xml';
import css from 'react-syntax-highlighter/dist/cjs/languages/hljs/css';
import json from 'react-syntax-highlighter/dist/cjs/languages/hljs/json';
import bash from 'react-syntax-highlighter/dist/cjs/languages/hljs/bash';
// Import a light theme to match your design
import { github } from 'react-syntax-highlighter/dist/cjs/styles/hljs';

// Register only the languages you commonly use
SyntaxHighlighter.registerLanguage('javascript', javascript);
SyntaxHighlighter.registerLanguage('js', javascript);
SyntaxHighlighter.registerLanguage('jsx', javascript);
SyntaxHighlighter.registerLanguage('typescript', typescript);
SyntaxHighlighter.registerLanguage('ts', typescript);
SyntaxHighlighter.registerLanguage('tsx', typescript);
SyntaxHighlighter.registerLanguage('python', python);
SyntaxHighlighter.registerLanguage('py', python);
SyntaxHighlighter.registerLanguage('html', xml);
SyntaxHighlighter.registerLanguage('xml', xml);
SyntaxHighlighter.registerLanguage('css', css);
SyntaxHighlighter.registerLanguage('json', json);
SyntaxHighlighter.registerLanguage('bash', bash);
SyntaxHighlighter.registerLanguage('shell', bash);

// Map of supported languages for reference
const supportedLanguages = [
  'javascript', 'js', 'jsx', 'typescript', 'ts', 'tsx',
  'python', 'py', 'bash', 'shell', 'css', 'html', 'json', 'xml'
];

export const Code: CustomComponent = ({ 
  node, 
  inline,
  className, 
  children, 
  ...props 
}) => {
  const match = /language-(\w+)/.exec(className || '');
  const lang = match && supportedLanguages.includes(match[1]) ? match[1] : null;
  
  if (inline) {
    return (
      <code className={className} {...props}>
        {children}
      </code>
    );
  }

  const code = String(children).replace(/\n$/, '');
  
  if (!lang) {
    return (
      <code className={className} {...props}>
        {code}
      </code>
    );
  }

  // Modified for proper containment
  return (
    <div className="max-w-full overflow-hidden">
      <SyntaxHighlighter
        language={lang}
        style={github}
        customStyle={{
          margin: 0,
          padding: 0,
          background: 'transparent',
          fontSize: '0.875rem',
          fontFamily: 'Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
          overflowX: 'auto',
          maxWidth: '100%',
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word'
        }}
        codeTagProps={{
          style: {
            fontSize: 'inherit',
            fontFamily: 'inherit'
          }
        }}
        wrapLines={true}
        PreTag="div"
        {...props}
      >
        {code}
      </SyntaxHighlighter>
    </div>
  );
};

export default Code;